import type { ArticleWithSubpages } from "./types"

// Each article followed by its subpages, the order the nav renders them in.
export function withSubpagesInNavOrder(
	articles: readonly ArticleWithSubpages[],
): ArticleWithSubpages[] {
	return articles.flatMap((article) => [article, ...(article.subpages ?? [])])
}
